import { HeaderText, Skeleton } from "@/components/ui";

interface VitalSkeletonProps {
  title: string;
  showDateTime?: boolean;
}

export const VitalSkeleton = ({
  title,
  showDateTime = true,
}: VitalSkeletonProps) => {
  return (
    <div className="flex flex-col gap-2 hover:bg-tertiary rounded transition-colors px-3 py-2">
      <HeaderText size="sm">{title}</HeaderText>
      <div className="flex flex-col gap-2">
        <Skeleton className="h-[18px] w-24" />
        {showDateTime && <Skeleton className="h-[14px] w-32" />}
      </div>
    </div>
  );
};
